/* global ga, TweenMax */

export default class ContactModal {

  constructor() {

    $('.cta--contact').click( (e) => { this.handleContactClick(e); });
    $('.overlay__close.contact').click( (e) => { this.closeContact(e); } );
    $('#contact-form').submit( (e) => { this.submitForm(e); } );

    this.formid = 'general_contact';

  }

  submitForm(e) {
    e.preventDefault();

    const data = $('#contact-form').serializeArray();

    if ( this.validateForm() ) {

      $('.form-progress').addClass('is-active');
      $('#contact-send').addClass('is-deactivated');

      $.post( '/', data, (response) => {
        if (response.success) {
          $('.form-progress').removeClass('is-active');
          $('#contact-send').addClass('is-hidden');
          ga('send', 'event', 'Contact Modal', 'success', this.formid);

          setTimeout( () => {
            $('.form-response').text('Thank you, your message has been sent.');
            $('.form-response').addClass('is-active');

            setTimeout( () => {
              this.closeContact();
            }, 3000 );
          }, 300);

        } else {
          // response.error will be an object containing any validation errors that occurred, indexed by field name
          // e.g. response.error.fromName => ['From Name is required']
          console.error('An error occurred. Please try again.', response);

          ga('send', 'event', 'Contact Modal', 'failure', this.formid);

          $('#contact-send').addClass('is-hidden');

          setTimeout( () => {
            $('.form-response').text('I\m sorry. There was an error sending your message.');
            $('.form-response').addClass('is-active');
          }, 300);

        }
      });

    }

  }

  validateForm() {
    let clean = true;

    if ( $('#fromEmail').val() === '' || $('#fromEmail').parent().hasClass('has-error') ) {
      clean = false;
      $('#fromEmail').parent().addClass('has-error');
    } else {
      $('#fromEmail').parent().removeClass('has-error');
    }

    if ( $('#contact-message').val() === $('#contact-message').data('default') || $('#contact-message').parent().hasClass('has-error') ) {
      clean = false;
      $('#contact-message').parent().addClass('has-error');
    } else {
      $('#contact-message').parent().removeClass('has-error');
    }

    return clean;
  }

  handleContactClick(e) {
    e.preventDefault();

    if ($('section.contact.c2').hasClass('is-active')) {
      this.closeContact();
    } else {
      this.openContact(e);
    }
  }


  openContact(e) {

    this.formid = $(e.currentTarget).data('formid');

    if ( $(e.currentTarget).data('title') !== undefined ) {
      $('#contact__title').text($(e.currentTarget).data('title'));
    } else {
      $('#contact__title').text($('#contact__title').data('default'));
    }

    if ( $(e.currentTarget).data('details') !== undefined ) {
      $('#contact__details').text($(e.currentTarget).data('details'));
    } else {
      $('#contact__details').text($('#contact__details').data('default'));
    }

    if ( $(e.currentTarget).data('formid') !== undefined ) {
      $('#contact__formid').text(this.formid);
    }

    ga('send', 'event', 'Contact Modal', 'open', this.formid);

    $('section.contact.c2').addClass('is-active');
    $('section.contact.c2 .modalAnchor').focus();

    $('section.contact.c2 .overlay__close').blur( () => {
      $('#contact-firstname').focus();
    });

    TweenMax.fromTo( $('section.contact.c2 .contact__form'), 1, { y: 20, opacity: 0 }, { opacity: 1, y: 0, delay: 0.25 } );

  }

  closeContact() {
    $('section.contact.c2').css('visibility', 'visible');
    $('section.contact.c2').removeClass('is-active');
    TweenMax.to( $('section.contact.c2 .contact__form'), 0.5, { y: -10, opacity: 0 } );
    ga('send', 'event', 'Contact Modal', 'close', this.formid);

    console.log(this.formid);

    setTimeout( () => {
      this.resetForm();
    }, 500 );
  }

  resetForm() {
    $('section.contact.c2 input[type="text"]').val('');
    $('section.contact.c2 textarea').val('Enter a message...');
    $('.form-formItem').removeClass('has-content has-error');
    $('.contact__form').scrollTop(0);
    $('.form-progress').removeClass('is-active');
    $('#contact-send').removeClass('is-deactivated is-hidden');
    $('.form-response').text('');
    $('.form-response').removeClass('is-active');
    $('section.contact.c2').css('visibility', '');
  }

}



// WEBPACK FOOTER //
// ./js/modules/ContactModal.js